import dayjs from "@shared/dayjs";

const DISPLAY_DATE_FORMAT = "MM/DD/YYYY";
const ACCEPTED_DATE_FORMATS = ["YYYY-MM-DD", "MM/DD/YYYY", "MM/DD/YY"];

// eslint-disable-next-line import/prefer-default-export
export const formatStageDate = (value) => {
  if (!value) return "";

  const parsed = dayjs(value, ACCEPTED_DATE_FORMATS);

  return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : value;
};
